module.exports = "/images/right-arrow.png?a6706282d8d9349b34e626a80a94800a";